// Barrel Export für Bohrpunkte-Komponenten

// Detail-Komponenten (Re-Export)
export * from './detail';

// Weitere Komponenten
export { GrubenbildComponent } from './grubenbild/grubenbild.component';
export { BohrpunktListComponent } from './list/bohrpunkt-list.component';
export { BohrpunktListPanelComponent } from './list-panel/bohrpunkt-list-panel.component';
// FilterComponent → verschoben nach @luzula/luzula-lib (WdFilterComponent)
export { ErrorComponent } from './error/error.component';
export { SandboxControlsComponent } from './sandbox/controls.component';
